import { AIBuilder } from '../components/AIBuilder/AIBuilder';

export function AIBuilderPage() {
  return <AIBuilder />;
}
